import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { Button, Card, CardBody } from "reactstrap";
import { DesktopContainer } from "../layouts";
import { constants, UserContext, } from "../utils";
import {
   ManageCARProblems, ManageConfig, ManageDefects, ManageDepartments, ManageExceptionMachines,
   ManageHoldReasons, ManageICARProblems, ManageLateReasons, ManageLateShipments,
   ManageMsrProcesses, ManagePcrTypes, ManagePrinters, ManagePurchaseSites, ManageRwoMachines,
   ManageRwoProblems, ManageSalespersons, ManageScheduleReasons, ManageSites
} from ".";

export default function AdminMaint() {
   const { currentUser } = useContext(UserContext);
   const navigate = useNavigate();
   const [showCARTypes, setShowCARTypes] = useState(false);         // CAR & ICAR Problems
   const [showDefects, setShowDefects] = useState(false);           // Defect Types
   const [showDepts, setShowDepts] = useState(false);               // Repair Departments
   const [showExceptionMachines, setShowExceptionMachines] = useState(false); // Production Exception Machines
   const [showHoldReasons, setShowHoldReasons] = useState(false);   // QC Hold Reasons
   const [showLateReasons, setShowLateReasons] = useState(false);   // Late Ship Reasons & Remove Late Shipment Records
   const [showMsrProcs, setShowMsrProcs] = useState(false);         // MSR Process Types
   const [showPcrTypes, setShowPcrTypes] = useState(false);         // PCR Process Types
   const [showPrinters, setShowPrinters] = useState(false);         // Printer Info
   const [showRwo, setShowRwo] = useState(false);                   // RWO Machines & RWO Problems
   const [showSalespersons, setShowSalespersons] = useState(false); // Salesperson DDL's and Cross-References
   const [showScheduleReasons, setShowScheduleReasons] = useState(false); // Production Schedule Reasons
   const [showShifts, setShowShifts] = useState(false);             // Shift Hours - 8 or 12
   const [showSites, setShowSites] = useState(false);               // Consigned Purchase & Transfer/IV Count sites

   useEffect(() => {
      if (!currentUser) return;
      if (!currentUser.isAdmin) {
         toast.error("Unauthorized");
         var nav = constants.ENDPOINTS.home;
         navigate(nav);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentUser])

   function ResetButtons(val) {
      if ((showCARTypes && val !== "showCARTypes")
         || (!showCARTypes && val === "showCARTypes"))
         setShowCARTypes(!showCARTypes);

      if ((showDefects && val !== "showDefects")
         || (!showDefects && val === "showDefects"))
         setShowDefects(!showDefects);

      if ((showDepts && val !== "showDepts")
         || (!showDepts && val === "showDepts"))
         setShowDepts(!showDepts);

      if ((showExceptionMachines && val !== "showExceptionMachines")
         || (!showExceptionMachines && val === "showExceptionMachines"))
         setShowExceptionMachines(!showExceptionMachines);

      if ((showHoldReasons && val !== "showHoldReasons")
         || (!showHoldReasons && val === "showHoldReasons"))
         setShowHoldReasons(!showHoldReasons);

      if ((showLateReasons && val !== "showLateReasons")
         || (!showLateReasons && val === "showLateReasons"))
         setShowLateReasons(!showLateReasons);

      if ((showMsrProcs && val !== "showMsrProcs")
         || (!showMsrProcs && val === "showMsrProcs"))
         setShowMsrProcs(!showMsrProcs);

      if ((showPcrTypes && val !== "showPcrTypes")
         || (!showPcrTypes && val === "showPcrTypes"))
         setShowPcrTypes(!showPcrTypes);

      if ((showPrinters && val !== "showPrinters")
         || (!showPrinters && val === "showPrinters"))
         setShowPrinters(!showPrinters);

      if ((showRwo && val !== "showRwo")
         || (!showRwo && val === "showRwo"))
         setShowRwo(!showRwo);

      if ((showSalespersons && val !== "showSalespersons")
         || (!showSalespersons && val === "showSalespersons"))
         setShowSalespersons(!showSalespersons);

      if ((showScheduleReasons && val !== "showScheduleReasons")
         || (!showScheduleReasons && val === "showScheduleReasons"))
         setShowScheduleReasons(!showScheduleReasons);

      if ((showShifts && val !== "showShifts")
         || (!showShifts && val === "showShifts"))
         setShowShifts(!showShifts);

      if ((showSites && val !== "showSites")
         || (!showSites && val === "showSites"))
         setShowSites(!showSites);
   }

   return (
      document.title = `Management Tools`,
      <DesktopContainer screenName="Management Tools">
         <div className="filter-header sticky-top">
            <div className="dashboard-button-container">
               <Button
                  children={"CAR Problems"}
                  className="filter-button"
                  onClick={() => ResetButtons("showCARTypes")}
                  active={showCARTypes}
               />
               <Button
                  children={"Defects"}
                  className="filter-button"
                  onClick={() => ResetButtons("showDefects")}
                  active={showDefects}
               />
               <Button
                  children={"Departments"}
                  className="filter-button"
                  onClick={() => ResetButtons("showDepts")}
                  active={showDepts}
               />
               <Button
                  children={"Exception Machines"}
                  className="filter-button"
                  onClick={() => ResetButtons("showExceptionMachines")}
                  active={showExceptionMachines}
               />
               <Button
                  children={"Late Shipments"}
                  className="filter-button"
                  onClick={() => ResetButtons("showLateReasons")}
                  active={showLateReasons}
               />
               <Button
                  children={"MSR Processes"}
                  className="filter-button"
                  onClick={() => ResetButtons("showMsrProcs")}
                  active={showMsrProcs}
               />
               <Button
                  children={"PCR Types"}
                  className="filter-button"
                  onClick={() => ResetButtons("showPcrTypes")}
                  active={showPcrTypes}
               />
            </div>
            <br/>
            <div className="dashboard-button-container">
               <Button
                  children={"Printers"}
                  className="filter-button"
                  onClick={() => ResetButtons("showPrinters")}
                  active={showPrinters}
               />
               <Button
                  children={"QC Hold"}
                  className="filter-button"
                  onClick={() => ResetButtons("showHoldReasons")}
                  active={showHoldReasons}
               />
               <Button
                  children={"RWO Settings"}
                  className="filter-button"
                  onClick={() => ResetButtons("showRwo")}
                  active={showRwo}
               />
               <Button
                  children={"Salespersons"}
                  className="filter-button"
                  onClick={() => ResetButtons("showSalespersons")}
                  active={showSalespersons}
               />
               <Button
                  children={"Schedule Reasons"}
                  className="filter-button"
                  onClick={() => ResetButtons("showScheduleReasons")}
                  active={showScheduleReasons}
               />
               <Button
                  children={"Shifts"}
                  className="filter-button"
                  onClick={() => ResetButtons("showShifts")}
                  active={showShifts}
               />
               <Button
                  children={"Sites"}
                  className="filter-button"
                  onClick={() => ResetButtons("showSites")}
                  active={showSites}
               />
            </div>
         </div>

         {showCARTypes ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Corrective Action Problems</span></div>
                  <hr />
                  <ManageCARProblems />
               </CardBody>
            </Card>
         ) : (false)}

         {showCARTypes ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Internal Corrective Action Problems</span></div>
                  <hr />
                  <ManageICARProblems />
               </CardBody>
            </Card>
         ) : (false)}

         {showDefects ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Defect Types</span></div>
                  <hr />
                  <ManageDefects />
               </CardBody>
            </Card>
         ) : (false)}

         {showDepts ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Repair Departments</span></div>
                  <hr />
                  <ManageDepartments />
               </CardBody>
            </Card>
         ) : (false)}

         {showExceptionMachines ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Production Exception Machines</span></div>
                  <hr />
                  <ManageExceptionMachines />
               </CardBody>
            </Card>
         ) : (false)}

         {showHoldReasons ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage QC Hold Reasons</span></div>
                  <hr />
                  <ManageHoldReasons />
               </CardBody>
            </Card>
         ) : (false)}

         {showLateReasons ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Remove Late Shipment Records</span></div>
                  <hr />
                  <ManageLateShipments />
               </CardBody>
            </Card>
         ) : (false)}

         {showLateReasons ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Late Shipment Reasons</span></div>
                  <hr />
                  <ManageLateReasons />
               </CardBody>
            </Card>
         ) : (false)}

         {showMsrProcs ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage MSR Process Types</span></div>
                  <hr />
                  <ManageMsrProcesses />
               </CardBody>
            </Card>
         ) : (false)}

         {showPcrTypes ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage PCR Process Types</span></div>
                  <hr />
                     <ManagePcrTypes />
               </CardBody>
            </Card>
         ) : (false)}

         {showPrinters ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Printers</span></div>
                  <hr />
                  <ManagePrinters />
               </CardBody>
            </Card>
         ) : (false)}

         {showRwo ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage RWO Machines</span></div>
                  <hr />
                  <ManageRwoMachines />
               </CardBody>
            </Card>
         ) : (false)}

         {showRwo ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage RWO Problems</span></div>
                  <hr />
                  <ManageRwoProblems />
               </CardBody>
            </Card>
         ) : (false)}

         {showSalespersons ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Salespersons</span></div>
                  <hr />
                  <ManageSalespersons />
               </CardBody>
            </Card>
         ) : (false)}

         {showScheduleReasons ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Production Schedule Reasons</span></div>
                  <hr />
                  <ManageScheduleReasons />
               </CardBody>
            </Card>
         ) : (false)}

         {showShifts ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Shifts</span></div>
                  <hr />
                  <ManageConfig />
               </CardBody>
            </Card>
         ) : (false)}

         {showSites ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Consigned Purchase Sites</span></div>
                  <hr />
                  <ManagePurchaseSites />
               </CardBody>
            </Card>
         ) : (false)}

         {showSites ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Transfer & Inventory Count Sites</span></div>
                  <hr />
                  <ManageSites />
               </CardBody>
            </Card>
         ) : (false)}

      </DesktopContainer >
   );
}
